import { App as CapApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

export interface AppLifecycleHandlers {
  onColdStart: () => Promise<void>;
  onResume: () => Promise<void>;
}

export function registerAppLifecycleHandlers(handlers: AppLifecycleHandlers): () => void {
  let disposed = false;
  let appStateListener: { remove: () => Promise<void> } | null = null;
  let isRunning = false;

  const runSafely = async (fn: () => Promise<void>): Promise<void> => {
    if (disposed || isRunning) return;
    isRunning = true;
    try {
      await fn();
    } finally {
      isRunning = false;
    }
  };

  void runSafely(handlers.onColdStart);

  const handleVisibility = () => {
    if (document.visibilityState === 'visible') {
      void runSafely(handlers.onResume);
    }
  };

  document.addEventListener('visibilitychange', handleVisibility);

  if (Capacitor.isNativePlatform()) {
    void CapApp.addListener('appStateChange', ({ isActive }) => {
      if (isActive) {
        void runSafely(handlers.onResume);
      }
    }).then((listener) => {
      if (disposed) {
        void listener.remove();
        return;
      }
      appStateListener = listener;
    });
  }

  return () => {
    disposed = true;
    document.removeEventListener('visibilitychange', handleVisibility);
    if (appStateListener) {
      void appStateListener.remove();
      appStateListener = null;
    }
  };
}
